import axios from "axios";

export const FastRechargeService = () => {

    const createOrder = async (form) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}v1/logged/fast-recharge/create-order`, form, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        });
    }

    return {
        createOrder
    }
};
